import * as translation from "./pl-PL.json";

export const translationPlPL = translation.default;
